module.exports = __webpack_public_path__ + "static/media/clancy-interreg-ns-horizontal.5a03eb36.png";